// extracted by mini-css-extract-plugin
export default {"container":"dIg75tF","threeLineLayout":"WlEuo5p","reducedPrice":"_22sbBtS","saleAmount":"_3VjzNxC"};